import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import equalHeight from '../functions/equalHeight';
import BackToTop from '../components/chunks/BackToTop';
import Truncate from 'react-truncate-html';
import PropTypes from 'prop-types';
import {APP_TITLE} from '../constants/config';
import { Helmet } from 'react-helmet';

class Browse extends React.Component{
    constructor(props){
        super(props);
    }

    componentDidMount() {
        this.componentDidUpdate();
    }

    componentDidUpdate() {
        equalHeight(document.querySelectorAll('.item .image'));
        equalHeight(document.querySelectorAll('.item .bg-white'), 20);
    }

    format(products) {
        let data = [];
        if(products.length < 1) return products;

        let groups = {};

        for(let product of products) {
            if(!groups[product.category.slug]) {
                groups[product.category.slug] = {category: product.category, products: []};
            }
            groups[product.category.slug].products.push(product);
        }
        data = Object.values(groups);

        return data;
    }

    render(){
        const groups = this.format(this.props.products);
        return(
            <div id="choices">
                <Helmet>
                    <title>All Products | {APP_TITLE}</title>
                </Helmet>
                {groups.map((g) =>
                <div key={g.category.term_id}>
                    <h2 className="entry-title text-primary">{g.category.name} products</h2>
                    <div className="row entry">
                        {g.products.map((b, i) =>
                            <div key={i} className="col-12 col-md-6 col-lg-4 col-xl-3 mb-5">
                                <Link to={"/product/" + b.slug} className="item product-small">
                                    <div className="image d-flex align-items-end">
                                        <img src={b.image} className="img-fluid" alt={b.name}/>
                                    </div>
                                    <div className="bg-white p-4">
                                        <span className="category d-inline-block bg-primary text-white">{b.category.name}</span>
                                        <h3 className="mt-3">{b.title}</h3>
                                        <div className="entry-content">
                                            <Truncate lines={3} dangerouslySetInnerHTML={{__html: b.content_filtered}}/>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        )}
                    </div>
                </div>
                )}
                <BackToTop />
            </div>
        );
    }
}

// Maps state from store to props
const mapStateToProps = (state) => {
    return {
        // You can now say this.props.books
        products: state.products
    };
};

Browse.propTypes = {
    products: PropTypes.array,
};

// Use connect to put them together
export default connect(mapStateToProps)(Browse);


// WEBPACK FOOTER //
// ./src/components/Browse.js